module.exports = __webpack_public_path__ + "static/media/edit_profile_image_icon.c22289bf.png";